import { createApp } from 'vue'
import DensityCalculator from './DensityCalculator.vue'
import './assets/global.css'

createApp(DensityCalculator).mount('#density')
